import * as types from './action-types';

// import { errorHandler } from '../../../utils/errors';

import InsightsApi from '../../api/InsightsApi';
import NotificationApi from '../../api/NotificationApi';
import InsightApi from '../../api/InsightsApi';

/*
 charts
 */
export const setInsightData = ({ data, title, notification }) => ({
  type: types.SET_INSIGHT_DATA,
  data,
  title,
  notification,
});

// graph detail

export const drillDown = ({ navTitle, drillDownData }) => ({
  type: 'INSIGHTS_DRILL_DOWN',
  navTitle,
  drillDownData,
});

export const drillUp = () => ({
  type: 'INSIGHTS_DRILL_UP',
});

/** Fetch grap Detail **/
export const fetchGraphDetail = (
  id,
  companyCode,
  countryCode,
  selectedFilters,
  restrictions
) => ({
  type: types.FETCH_GRAPH_DETAIL,
  payload: InsightsApi.getGraphDetail(
    id,
    companyCode,
    countryCode,
    selectedFilters,
    restrictions
  ),
});

export const setFetchGraphData = status => ({
  type: types.SET_FETCH_GRAPH_DATA,
  payload: {
    status,
  },
});

export const fetchSummaryDetails = ({ FetchParams, navTitle }) => ({
  type: types.FETCH_SUMMARY_DETAILS,
  payload: InsightsApi.getSummaryDetail(FetchParams),
  meta: { FetchParams, navTitle },
});

/** Fetch Total till date by key **/
export const fetchTotalTillDateByKey = (
  graphId,
  companyCode,
  countryCode,
  filterKeyId
) => ({
  type: types.FETCH_TOTAL_TILL_DATE,
  payload: InsightsApi.getTotalTillDateByKey(
    graphId,
    companyCode,
    countryCode,
    filterKeyId
  ),
});

export const fetchDataFromTable = tableData => {
  if (!tableData || tableData.data.length === 0) {
    return {
      type: `${types.FETCH_GRAPH_DETAIL}_PENDING`,
      payload: tableData,
    };
  } else {
    return {
      type: `${types.FETCH_GRAPH_DETAIL}_FULFILLED`,
      payload: tableData,
    };
  }
};

// Fetch notification detail
export const fetchNotificationDetail = reportParams => ({
  type: types.FETCH_NOTIFICATION_DETAIL,
  payload: InsightsApi.getNotificationDetail(reportParams),
});

export const setReportParams = reportParams => ({
  type: types.SET_REPORT_PARAMS,
  data: reportParams,
});

export const clearReportParams = reportParams => ({
  type: types.CLEAR_REPORT_PARAMS,
});

// reset flag
export const resetRefreshFlag = () => ({
  type: types.RESET_OTHER_NOTIFICATIONS_UPDATE,
});

//Get Filters
export const getGraphFilters = params => ({
  type: types.GET_GRAPH_FILTER,
  payload: InsightsApi.getGraphFilters(params),
});

//Send Get Telematics Email
export const sendGetTelematicsEmail = data => ({
  type: 'Send Get Telematics Email',
  payload: InsightsApi.sendGetTelematicsEmail(data),
});



// WEBPACK FOOTER //
// ./src/features/insights/actions.js